import { render, staticRenderFns } from "./AreasLayer.vue?vue&type=template&id=74f3d7ca&scoped=true&"
import script from "./AreasLayer.vue?vue&type=script&lang=js&"
export * from "./AreasLayer.vue?vue&type=script&lang=js&"
import style0 from "./AreasLayer.vue?vue&type=style&index=0&id=74f3d7ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f3d7ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74f3d7ca')) {
      api.createRecord('74f3d7ca', component.options)
    } else {
      api.reload('74f3d7ca', component.options)
    }
    module.hot.accept("./AreasLayer.vue?vue&type=template&id=74f3d7ca&scoped=true&", function () {
      api.rerender('74f3d7ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AreasLayer.vue"
export default component.exports